export default __webpack_public_path__ + "static/patreon-b914d10ff0e019dc8c8139dfb622c436.png";